import app from 'flarum/forum/app';
import { slug } from '../../common';
import HomeDiscussions from './HomeDiscussions';
import BlogArticleItem from './Blog/BlogArticleItem';
import LinkButton from 'flarum/common/components/LinkButton';

// Make translation calls shorter
const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.home.blog`;

export default class HomeBlog extends HomeDiscussions {
	get preloadedKey() {
		return this.attrs.preloadedKey ? this.attrs.preloadedKey : 'blog';
	}

	get defaultParams() {
		let { params } = this.attrs;
		const defaultParams = { include: [], filter: {}, sort: '-createdAt' };
		params = {
			...defaultParams,
			...params,
		};

		// We cannot use filter parameters, as the v17 blog api hasn't
		// implemented them yet. So we have to use the "q" parameter.
		// params.filter.isBlog = true;
		params.filter = params.filter || {};
		params.filter.q = 'is:blog';

		// Include the blogMeta relationship, so we can get the blog
		// description and image.
		params.include.push('blogMeta');

		return params;
	}

	get titleText() {
		return t(`${prfx}.title`);
	}

	listItem(article) {
		return (
			<li key={article.id()} data-id={article.id()}>
				<BlogArticleItem article={article} />
			</li>
		);
	}

	get baseClass() {
		return 'HomeBlog';
	}

	get button() {
		return (
			<LinkButton className='HomeBlog-link Button' href={app.route('blog')}>
				{t(`${prfx}.all_articles`)}
			</LinkButton>
		);
	}
}
